import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {DepartmentService, IndicatorService,} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';


@Component({
  selector: 'pas-dialog-department',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton,
    MatButton,
    MultiSelect3Component,
  ],
})
export class DialogComponent implements OnInit {

  isNew: boolean = false;


  form = new FormGroup({
    name: new FormControl<string>('',[Validators.required]),
    indicators: new FormControl<Indicator[]>([], [Validators.required]),
  })
  isEnabled: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    public dataService: DepartmentService,
    public indicatorService: IndicatorService,
  ) {
    this.isNew = data['isNew'];
    console.log('isNew', this.isNew, this.data);

    if (!this.isNew) {
      (this.dataService as any)['apiDepartmentIdGet']({id: this.data['id']}).subscribe((i: Department) => {
        console.log('i', i);
        if (!i) return;
        i.name && this.form.get('name')!.setValue(i.name);
        i.indicators && this.form.get('indicators')!.setValue(i.indicators);
      })
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onApply() {
    if(this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }

  ngOnInit() {
    this.form.valueChanges.subscribe((v)=>{
      console.log('organization',v);
    })
  }

  onReset() {
    this.form.reset();
    this.form.get('indicators')!.setValue([]);
  }
}

